import { AnalyticsBrowser } from '@customerio/cdp-analytics-browser';

const writeKey = import.meta.env.VITE_CUSTOMERIO_WRITE_KEY;
const environment = import.meta.env.VITE_CUSTOMERIO_ENVIRONMENT || 'production';
const cdnURL = 'https://cdp-eu.customer.io';

const analyticsInstance = AnalyticsBrowser.load({
  writeKey,
  ...(cdnURL && { cdnURL }),
});

export const cioanalytics = {
  identifyEmployee(hrParams, client, user, adminAccess) {
    try {
      const userId = `${client.id}-${hrParams.companyId}-${hrParams.employeeId}`;
      const traits = {
        email: hrParams.email,
        name: `${user.firstName} ${user.lastName}`,
        first_name: user.firstName,
        last_name: user.lastName,
        phone: hrParams.phoneNumber,
        birthday: hrParams.birthdate,
        sprout_user_id: hrParams.sproutUserId,
        employee_id: hrParams.employeeId,
        employment_status: hrParams.employmentStatus,
        payroll_type: hrParams.payrollType,
        hire_date: hrParams.hireDate,
        expected_separation_date: hrParams.expectedSeparationDate,
        separation_date: hrParams.separationDate,
        employee_type: hrParams.employeeType,
        dashboard_type: user.dashboardType,
        is_readycash_admin: adminAccess.isInstaCashAdmin,
        is_readywage_admin: adminAccess.isInstaWageAdmin,
        environment,
      };
      return analyticsInstance.identify(userId, traits);
    } catch (err) {
      console.error('Failed to identify employee in Customer.io:', err);
      throw err;
    }
  },

  groupCompany(hrParams, client, adminAccess) {
    try {
      const groupId = `${client.id}-${hrParams.companyId}`;
      const traits = {
        objectTypeId: 1,
        hr_client_id: client.id,
        hr_company_id: hrParams.companyId,
        name: hrParams.companyName,
        hr_client_url: hrParams.clientUrl,
        has_mobile: hrParams.hasMobile,
        has_readycash: hrParams.hasInstacash,
        has_readywage: adminAccess.hasReadyWage,
        environment,
      };
      return analyticsInstance.group(groupId, traits);
    } catch (err) {
      console.error('Failed to group company in Customer.io:', err);
      throw err;
    }
  },

  identify(userId, traits = {}) {
    return analyticsInstance.identify(userId, {
      ...traits,
      environment,
    });
  },

  track(event, properties = {}) {
    return analyticsInstance.track(event, {
      ...properties,
      environment,
    });
  },

  page(properties = {}) {
    return analyticsInstance.page({
      ...properties,
      environment,
    });
  },

  trackPageView(pageName, properties = {}) {
    return analyticsInstance.page({
      name: pageName,
      ...properties,
      environment,
    });
  },

  reset() {
    return analyticsInstance.reset();
  },

  user() {
    return analyticsInstance.user();
  },

  get raw() {
    return analyticsInstance;
  },

  get environment() {
    return environment;
  },
};
